/**
 * 债券顶部基本信息
 */
import React from "react"
import { store } from "./store"
import { single_quote, quote_item_name, quote_chart } from "../../shared/quotedata/index"
import { Observer } from "mobx-react-lite"
import { BondLoadMore, LoadMore } from "../../shared/quote_load_more"
import { ChartType } from "../../shared/utils"
import { PageBondType, StockErrorTradeStatus } from "../../shared/pagetype"
import { quotedata } from "../../shared/quotedata"
import { StockHeaderErrorTradeStatus } from "../../shared/error_trade_status"

export function BondBasicInfo(props: { quotedata: quotedata; bondsubtype: PageBondType, trade_status:StockErrorTradeStatus }) {

  return (
    <Observer>
      {() => (
        <>
          {(props.bondsubtype == PageBondType.上证可转债 || props.bondsubtype == PageBondType.深证可转债) && <KZZBasicInfo quotedata={props.quotedata} bondsubtype={props.bondsubtype} trade_status={props.trade_status}/>}
          {(props.bondsubtype == PageBondType.上证质押式回购 || props.bondsubtype == PageBondType.深证质押式回购) && <ZZHGBasicInfo quotedata={props.quotedata} bondsubtype={props.bondsubtype} trade_status={props.trade_status}/>}
          {props.bondsubtype == PageBondType.上证现券 && <SHBondBasicInfo trade_status={props.trade_status}/>}
          {(props.bondsubtype == PageBondType.深证现券 || props.bondsubtype == PageBondType.北证债券) && <SZBondBasicInfo trade_status={props.trade_status}/>}
        </>
      )}
    </Observer>
  )
}

// 一般上证债券
export function SHBondBasicInfo(props: { trade_status:StockErrorTradeStatus }) {
  return (
    <Observer>
      {() => (
        <div className="bond-container">
          <div className="bond-container-left">
            <StockHeaderErrorTradeStatus store={store} trade_status={props.trade_status} />
          </div>
          <div className="bond-container-right">
            {store.chart_mouse_move_data ? (
              <>
                <ul>
                  <li>
                    <p>成交量</p>
                    {quote_chart[quote_item_name.成交量](store.chart_mouse_move_data.volume).element}
                  </li>
                  <li>
                    <p>最新YTM</p>
                    {single_quote[quote_item_name.最新YTM](store.StockDetail).new_element}
                  </li>
                </ul>
                <ul>
                  <li>
                    <p>成交额</p>
                    {quote_chart[quote_item_name.成交额](store.chart_mouse_move_data.amount).new_bond_element}
                  </li>
                  <li>
                    <p>涨跌BP</p>
                    {single_quote[quote_item_name.涨跌BP](store.StockDetail).new_bond_element}
                  </li>
                </ul>
              </>
            ) : (
              <>
                <ul>
                  <li>
                    <p>成交量</p>
                    {single_quote[quote_item_name.成交量](store.StockDetail).new_bond_element}
                  </li>
                  <li>
                    <p>最新YTM</p>
                    {single_quote[quote_item_name.最新YTM](store.StockDetail).new_element}
                  </li>
                </ul>
                <ul>
                  <li>
                    <p>成交额</p>
                    {single_quote[quote_item_name.成交额](store.StockDetail).bond_element}
                  </li>
                  <li>
                    <p>涨跌BP</p>
                    {single_quote[quote_item_name.涨跌BP](store.StockDetail).new_bond_element}
                  </li>
                </ul>
              </>
            )}
          </div>
          <BondLoadMore />
        </div>
      )}
    </Observer>
  )
}

// 一般深证债券
export function SZBondBasicInfo(props: { trade_status:StockErrorTradeStatus }) {
  return (
    <Observer>
      {() => (
        <div className="bond-container">
          <div className="bond-container-left">
          <StockHeaderErrorTradeStatus store={store} trade_status={props.trade_status} />

          </div>
          <div className="bond-container-right">
            <ul>
              <li>
                <p>总成交量</p>
                {store.chart_mouse_move_data && store.chartType != ChartType.分时 && store.chartType != ChartType.五日 ? quote_chart[quote_item_name.成交量](store.chart_mouse_move_data.volume).element : single_quote[quote_item_name.成交量](store.StockDetail).bond_element}
              </li>
              <li>
                <p>最新YTM</p>
                {single_quote[quote_item_name.最新YTM](store.StockDetail).element}
              </li>
            </ul>
            <ul>
              <li>
                <p>总成交额</p>
                {store.chart_mouse_move_data && store.chartType != ChartType.分时 && store.chartType != ChartType.五日 ? quote_chart[quote_item_name.成交额](store.chart_mouse_move_data.amount).bond_element : single_quote[quote_item_name.成交额](store.StockDetail).bond_element}
              </li>
              <li>
                <p>最近成交方式</p>
                {single_quote[quote_item_name.最近成交方式](store.StockDetail).element}
              </li>
            </ul>
          </div>
          <BondLoadMore />
        </div>
      )}
    </Observer>
  )
}

// 可转债
function KZZBasicInfo(props: { quotedata: quotedata; bondsubtype: PageBondType, trade_status:StockErrorTradeStatus }) {
  return (
    <Observer>
      {() => (
        <div className="datas">
          <div className="top-p">
          <StockHeaderErrorTradeStatus store={store} trade_status={props.trade_status} />
            <div>
              <div className="row">
                {store.chartType != ChartType.分时 && store.chartType != ChartType.五日 && store.chart_mouse_move_data ? (
                  <>
                    <p>
                      <span>今开</span>
                      {quote_chart[quote_item_name.今开](store.chart_mouse_move_data.jinkai, store.chart_mouse_move_data.jkColor).element}
                    </p>
                    <p>
                      <span>最高</span>
                      {quote_chart[quote_item_name.最高](store.chart_mouse_move_data.maxPrice, store.chart_mouse_move_data.maxPriceColor).element}
                    </p>
                    <p>
                      <span>最低</span>
                      {quote_chart[quote_item_name.最低](store.chart_mouse_move_data.minPrice, store.chart_mouse_move_data.minPriceColor).element}
                    </p>
                  </>
                ) : (
                  <>
                    <p>
                      <span>今开</span>
                      {single_quote[quote_item_name.今开](store.StockDetail).element}
                    </p>
                    <p>
                      <span>最高</span>
                      {single_quote[quote_item_name.最高](store.StockDetail).element}
                    </p>
                    <p>
                      <span>最低</span>
                      {single_quote[quote_item_name.最低](store.StockDetail).element}
                    </p>
                  </>
                )}
              </div>
              <div className="row">
                {store.chart_mouse_move_data ? (
                  <>
                    <p>
                      <span>总手</span>
                      {quote_chart[quote_item_name.总手](store.chart_mouse_move_data.zongshou).element}
                    </p>
                    <p>
                      <span>金额</span>
                      {quote_chart[quote_item_name.成交额](store.chart_mouse_move_data.amount).bond_element}
                    </p>
                    <p>
                      <span>量比</span>
                      {quote_chart[quote_item_name.量比](store.chart_mouse_move_data.liangbi).element}
                    </p>
                  </>
                ) : (
                  <>
                    <p>
                      <span>总手</span>
                      {single_quote[quote_item_name.总手](store.StockDetail).element}
                    </p>
                    <p>
                      <span>金额</span>
                      {single_quote[quote_item_name.成交额](store.StockDetail).element}
                    </p>
                    <p>
                      <span>量比</span>
                      {single_quote[quote_item_name.量比](store.StockDetail).element}
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="bottom-p">
            <>
              <p>
                <span>昨收</span>
                {single_quote[quote_item_name.昨收](store.StockDetail).element}
              </p>
              <p>
                <span className="stock-span">转股价值</span>
                {single_quote[quote_item_name.转股价值](store.StockDetail).element}
              </p>
              <p>
                <span className="stock-span">转股溢价</span>
                {single_quote[quote_item_name.转股溢价率](store.StockDetail).element}
              </p>
              <LoadMore />
            </>
          </div>
        </div>
      )}
    </Observer>
  )
}

// 质押式回购
function ZZHGBasicInfo(props: { quotedata: quotedata; bondsubtype: PageBondType,trade_status:StockErrorTradeStatus  }) {
  return (
    <Observer>
      {() => (
        <div className="bond-container">
          <div className="bond-container-left">
          <StockHeaderErrorTradeStatus store={store} trade_status={props.trade_status} />
          </div>
          <div className="bond-container-right">
            <ul>
              <li>
                <p>计息天数</p>
                {single_quote[quote_item_name.计息天数](store.StockDetail).element}
              </li>
              <li>
                <p>资金可用</p>
                {single_quote[quote_item_name.资金可用日](store.StockDetail).new_element}
              </li>
            </ul>
            <ul>
              <li>
                <p>万元收益</p>
                {single_quote[quote_item_name.万元收益](store.StockDetail).new_element}
              </li>
              <li>
                <p>资金可取</p>
                {single_quote[quote_item_name.资金可取日](store.StockDetail).new_element}
              </li>
            </ul>
          </div>
          <BondLoadMore />
        </div>
      )}
    </Observer>
  )
}
